import MonthDateCellHeader from './MonthDateCellHeader';

export default MonthDateCellHeader;
